import { render, staticRenderFns } from "./ID.vue?vue&type=template&id=508e99ec&scoped=true&"
import script from "./ID.vue?vue&type=script&lang=js&"
export * from "./ID.vue?vue&type=script&lang=js&"
import style0 from "./ID.vue?vue&type=style&index=0&id=508e99ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508e99ec",
  null
  
)

export default component.exports